<template>
  <button class="MultichoiceOption" :disabled="isDisabled">
    <MultichoiceRadio v-bind="{ isSelected }" />
    <span class="text">{{ text }}</span>
  </button>
</template>

<script>
import MultichoiceRadio from './MultichoiceRadio.vue'

export default {
  components: {
    MultichoiceRadio,
  },
  props: {
    text: String,
    isDisabled: Boolean,
    isSelected: Boolean,
  },
}
</script>

<style scoped>
.MultichoiceOption {
  background-color: white;
  border-radius: 8px;
  padding: var(--spacing-4) var(--spacing-5);
  display: flex;
  align-items: center;
  column-gap: var(--spacing-4);
  transition: background-color 0.15s;
}
.MultichoiceOption:hover {
  background-color: #eee;
}
.text {
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}
</style>
